import FnCheckbox from '../../../../components/elements/FnCheckbox';
import React, { FC, memo, useCallback, useEffect, useState } from 'react';
import { TCheckBoxListValue, TCurrentFilter } from '../../../../commonTypes/filters';

interface Props {
  internalName: string;
  label: string;
  defaultValues: TCheckBoxListValue[];
  currentFilterItems: TCurrentFilter[];
  onSetFilter: (data: TCurrentFilter) => void;
  onClearFilter: (data: string) => void;
}

const CheckBoxTreeListTitle: FC<Props> = ({
  internalName,
  label,
  currentFilterItems,
  defaultValues,
  onSetFilter,
  onClearFilter
}: Props) => {
  const [value, setValue] = useState(false);

  const handleChange = useCallback(
    (checked) => {
      const values = checked ? defaultValues.map((item) => item.value) : [];

      if (values.length) {
        onSetFilter({ internalName, values });
      } else {
        onClearFilter(internalName);
      }
    },
    [onSetFilter, internalName, defaultValues, onClearFilter]
  );

  useEffect(() => {
    const currentFilterItem = currentFilterItems?.find((item) => item.internalName === internalName);

    if (!currentFilterItem) {
      setValue(false);
      return;
    }

    setValue(currentFilterItem.values.length === defaultValues.length);
  }, [currentFilterItems, defaultValues]);

  return <FnCheckbox onChange={handleChange} value={value} label={label} name={`CheckBoxTreeList-${internalName}`} />;
};

export default memo(CheckBoxTreeListTitle);
